export const scalarCustomCss = `
.scalar-app {
  --scalar-font: var(--font-sans);
  --scalar-font-code: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  --scalar-background-1: var(--surface);
  --scalar-background-2: var(--background);
  --scalar-background-3: var(--muted);
  --scalar-background-accent: var(--info-soft);
  --scalar-color-1: var(--anchor);
  --scalar-color-2: var(--muted-foreground);
  --scalar-color-3: var(--muted-foreground);
  --scalar-color-accent: var(--primary);
  --scalar-border-color: var(--border);
  --scalar-radius: 10px;
  --scalar-radius-lg: 14px;
  --scalar-radius-xl: 18px;
  --scalar-border-width: 1px;
  --scalar-shadow-1: var(--shadow-card);
  --scalar-shadow-2: var(--shadow-pop);
}

.dark .scalar-app {
  --scalar-background-1: var(--surface);
  --scalar-background-2: var(--background);
  --scalar-background-3: var(--muted);
  --scalar-color-1: var(--anchor);
  --scalar-color-2: var(--muted-foreground);
  --scalar-color-3: var(--muted-foreground);
  --scalar-border-color: var(--border);
}

.scalar-app a {
  color: var(--anchor);
}

.scalar-app button {
  font-family: var(--font-sans);
}

.scalar-app .references-layout {
  min-height: calc(100vh - 13rem);
}
`;
